module.exports = __webpack_public_path__ + "img/calligraphy-work-icon6.69879b42.jpg";